import { useEffect, useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import lzoImg from "../../../../../picture/sredstva-oprema.png";
import axios from "axios";

function ShowBarLZO() {
  const [kategorije, setKategorije] = useState([]);
  const [otvoreneKategorije, setOtvoreneKategorije] = useState({});
  const { baseUrl, folderDokumentCurrentState, setLzoScrollToId } =
    useGlobalContext();

  useEffect(() => {
    if (folderDokumentCurrentState !== "DODAVANJE_POSTOJECI") return;
    const fetchKatalog = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/lzo_katalog/read.php`,
          {},
        );
        if (data.status === 200) {
          // Grupiši po kategoriji
          const grouped = data.data.reduce((acc, item) => {
            if (!acc[item.kategorija]) acc[item.kategorija] = [];
            acc[item.kategorija].push(item);
            return acc;
          }, {});
          setKategorije(grouped);
        }
      } catch (e) {
        console.error(e);
      }
    };
    fetchKatalog();
  }, [folderDokumentCurrentState]);

  const toggleKategorija = (naziv) => {
    setOtvoreneKategorije((prev) => ({ ...prev, [naziv]: !prev[naziv] }));
  };

  const handleKlikStavka = (id) => {
    setLzoScrollToId(id);
  };

  if (folderDokumentCurrentState !== "DODAVANJE_POSTOJECI") return null;

  return (
    <div style={{ backgroundColor: "white" }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: "10px",
        }}
      >
        <img src={lzoImg} style={{ width: "40%" }} />
      </div>

      <div style={{ overflowY: "auto", maxHeight: "calc(100vh - 120px)" }}>
        {Object.entries(kategorije).map(([naziv, stavke]) => (
          <div key={naziv}>
            {/* Kategorija header */}
            <div
              onClick={() => toggleKategorija(naziv)}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <Button
                active={otvoreneKategorije[naziv]}
                style={{
                  padding: "7px",
                  fontWeight: "bold",
                  textAlign: "left",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "13px",
                  width: "30px",
                  margin: "5px 10px"
                }}
              >
                <span style={{fontSize: "18px" }}>
                  {otvoreneKategorije[naziv] ? "−" : "+"}
                </span>
              </Button>
                <span style={{ fontWeight: "bold" }}>{naziv}</span>
            </div>

            {/* Stavke kategorije */}
            {otvoreneKategorije[naziv] && (
              <div style={{ borderLeft: "3px solid #ccc", marginLeft: "12px" }}>
                {stavke.map((stavka) => (
                  <div
                    key={stavka.id}
                    onClick={() => handleKlikStavka(stavka.id)}
                    style={{
                      padding: "6px 10px",
                      fontSize: "13px",
                      cursor: "pointer",
                      borderBottom: "1px solid #f0f0f0",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f5f5f5")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    {stavka.naziv}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ShowBarLZO;
